import * as QueryString from "querystringify";
import * as React from "react";
import { Link } from "react-router-dom";
import { PublicPage } from "../../components/page";
import { Utility } from "../../utils";

interface OwnProps {
    title?: string;
    message?: JSX.Element | string;
}

interface OwnState {
}

export class AccessDenied extends React.Component<OwnProps, OwnState> {
    public static defaultProps: OwnProps = {
        title: "Access denied",
        message: <p>You do not have access to view the requested page.</p>,
    };

    public render() {

        let url = "";
        if (typeof window !== "undefined" && window.location && window.location.search) {
            const query = QueryString.parse(window.location.search) as any;
            if (query.url) {
                url = decodeURIComponent(query.url);
            }
        }

        const host = Utility.getUrlHost();

        return <PublicPage wrapperId="content">
            <h1>{this.props.title}</h1>
            {this.props.message}

            {url
                ? <p>URL accessed: <Link to={url}>{host}{url}</Link></p>
                : null}

            {this.props.children}
        </PublicPage>;
    }
}



// WEBPACK FOOTER //
// ./src/containers/account/AccessDenied.tsx